import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { Router } from '@angular/router';
import { TranslocoModule } from '@ngneat/transloco';
import { ButtonModule } from 'primeng/button';

@Component({
  selector: 'app-unauthorized-page',
  standalone: true,
  imports: [ButtonModule, TranslocoModule],
  templateUrl: './unauthorized-page.component.html',
  styleUrl: './unauthorized-page.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class UnauthorizedPageComponent {
  private readonly router = inject(Router);
  
  goLogin(): void {
    this.router.navigateByUrl('/login');
  }
}
